import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule, NumericTextBoxAllModule, NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { ColumnChooserService, FilterService, GridModule, PageService, ResizeService, SortService } from '@syncfusion/ej2-angular-grids';
import { VendorComponent } from './vendor.component';
import { VendorService } from './vendor.service';
import { VendorRoutingModule } from './vendor-routing.module';
import { vendorgridlist } from './vendordata.service';

@NgModule({
  declarations: [
    VendorComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    NgSelectModule,
    MultiselectDropdownModule,
    NumericTextBoxModule,
    NumericTextBoxAllModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    VendorRoutingModule

  ],
  providers: [ColumnChooserService, PageService, SortService, FilterService, ResizeService, VendorService, vendorgridlist]
})
export class vendorModule { }
